import {
  WSButton,
  WSCard,
  WSElement,
  WSInfoBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../../Onboarding";
import { useTaxWithholdingsStatus } from "../../hooks/useTaxWithholdingsStatus";
import { PATH_TAXES, PATH_TAXES_EDIT_TAX_RATE } from "../../paths";
import styles from "./index.module.scss";

type Props = {
  isSettings?: boolean;
};

export const CardTaxWithholdingStatus: React.FC<Props> = props => {
  const history = useHistory();

  const {
    isActive,
    rate,
    shouldCompleteSetup,
    taxWithholdingAccount,
    updateMeta,
    turnOn,
    turnOff
  } = useTaxWithholdingsStatus();

  return (
    <WSCard
      actions={{
        alignment: "left",
        buttons: shouldCompleteSetup
          ? [
              {
                kind: "Link",
                label: "Complete setup",
                rightIcon: "chevron-right",
                onClick: () => {
                  history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
                }
              }
            ]
          : props.isSettings
          ? [
              {
                kind: "Link",
                label: "View tax withholdings",
                rightIcon: "chevron-right",
                onClick: () => {
                  history.push(PATH_TAXES);
                }
              }
            ]
          : [
              {
                kind: "Link",
                label: "Update tax profile",
                rightIcon: "chevron-right",
                onClick: () => {
                  history.push(PATH_TAXES_EDIT_TAX_RATE);
                }
              }
            ]
      }}
    >
      <WSList gap="XL">
        <WSElement className={styles.statusContainer}>
          {isActive ? (
            <>
              <WSPill theme="success" text="Withholdings on" badge />
              <WSButton.Link
                size="S"
                onClick={turnOff}
                loading={updateMeta.isLoading}
              >
                Turn off
              </WSButton.Link>
            </>
          ) : (
            <>
              <WSPill theme="warning" text="Withholdings off" badge />
              <WSButton.Link
                size="S"
                onClick={turnOn}
                loading={updateMeta.isLoading}
              >
                Turn on
              </WSButton.Link>
            </>
          )}
        </WSElement>

        {isActive && taxWithholdingAccount?.status !== "Active" && (
          <WSInfoBox>
            Your withholdings are on. <b>Once your activation is complete,</b>{" "}
            you will start setting aside a portion of your income for taxes.
          </WSInfoBox>
        )}

        {!isActive && (
          <WSInfoBox>
            Your withholdings are off. Turn them on to set aside a portion of
            your income for taxes.
          </WSInfoBox>
        )}

        {!!rate && (
          <>
            <WSText weight="medium" color="gray600">
              My withholding rate is
            </WSText>

            <WSText.Heading1 weight="book" color="gray500">
              {rate}%
            </WSText.Heading1>

            <WSText.ParagraphSm color="gray500" weight="book">
              The proportion of income set aside so you are financially prepared
              for taxes
            </WSText.ParagraphSm>
          </>
        )}
      </WSList>
    </WSCard>
  );
};
